let openTabs = {};

window.openOrReloadTab = function (pageUrl, tabName, tabType) {
    if (tabType == "DualScreen") {
        // Check if the tab with the given tabName exists and is not closed
        if (openTabs[tabName] && !openTabs[tabName].closed) {
            openTabs[tabName].focus(); // Focus on the tab
        } else {
            // If no existing tab, open a new tab and assign it to openTabs
            openTabs[tabName] = window.open(pageUrl, tabName);
            setTimeout(() => {
                try {
                    openTabs[tabName].location.href = pageUrl;
                    openTabs[tabName].focus(); // Focus on the tab
                } catch (error) {
                    console.error('Error while loading page:', error);
                }
            }, 500);
        }
    } else {
        // For tabType other than Single / Dual Screen, open a new tab
        openTabs[tabName + Date.now().toString()] = window.open(pageUrl, '_blank');
    }

    if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        window.exitFullscreen();
    }
}

window.closeTab = function () {
    openTabs = {}; // Reset Opened Tabs
    window.close();
}


window.addEventListener("storage", async function (event) {

    //======== Job Order Page =============//
    if (event.key === "Job Order Details Data") {
        //console.log("🔄 Updated Job Order in another tab, syncing...");
        let windowMode = localStorage.getItem("WindowMode");
        if (windowMode) {
            windowMode = windowMode.replace(/^"|"$/g, '');
        }

        if (windowMode && windowMode == "DualScreen") {
            try
            {
                await DotNet.invokeMethodAsync('PMS.Web.Client', 'UpdateJobOrderFromLocalStorage');
                await DotNet.invokeMethodAsync('PMS.Web.Client', 'ReceiveMessageFromTabs');
            }
            catch (err)
            {
                console.error("Error updating state (js)", err);
            }
        }
    }

    //======== Job Plan Page =============//
    if (event.key === "SelectedJobPlan") {
        //console.log("🔄 Updated JobPlan in another tab, syncing...");
        let windowMode = localStorage.getItem("WindowMode");
        if (windowMode) {
            windowMode = windowMode.replace(/^"|"$/g, '');
        }

        if (windowMode && windowMode == "DualScreen") {
            try
            {
                await DotNet.invokeMethodAsync('PMS.Web.Client', 'ReceiveSelectedJobPlanData');
            }
            catch (err)
            {
                console.error("Error updating state (js)", err);
            }
        }
    }
});

window.test = function () {
    alert("test success");
    console.log("test success")
}